import { CacheableDataObject } from 'models/CacheableDataObject';

export default class Bug extends CacheableDataObject {

}
Bug.prototype.dataLocationParsers = {
	submitter: (bug, data) => {
		bug.submitter = Users.update(data.submitter);
	},
};

/**

 confirmed: false
 description: "44444"
 fixed: false
 id: 20374
 shown: true
 submitter: {display_name: null, max_tier_achievement: null, location: {…}, id: 1, username: "Ant_Her", …}
 testing: false
 title: "Ant_Her reporting aguyWithALongNa"
 url: "http://localhost/smashladder/mod_reports/detail/20374/Ant-Her-reporting-aguyWithALongNa"

 */